import { commonForms } from '../common/forms';
import { Forms } from '../types';

export const CAForms: Forms = {
  ...commonForms,
  orderLookUpReturns: [
    [
      {
        name: 'orderNo',
        type: 'input',
        inputType: 'text',
        required: true,
      },
    ],
    [{ name: 'orderEmail', type: 'input', inputType: 'email', required: true }],
    [{ name: 'billingPostalCode', type: 'input', required: true }],
    [
      {
        name: 'returnsOrderExplainerModal',
        type: 'text-to-modal',
        required: true,
      },
    ],
    [
      {
        name: 'submitButton',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
};
